import CCLFApplicationInformation from "components/Rover/DeveloperApplications/CCLFDevelopersIntake/CCLFDeveloperApplication/CCLFApplicationInformation";
import CCLFApplicationLoan from "components/Rover/DeveloperApplications/CCLFDevelopersIntake/CCLFDeveloperApplication/CCLFApplicationLoan";
import CCLFDisclosuresReferences from "components/Rover/DeveloperApplications/CCLFDevelopersIntake/CCLFDeveloperApplication/CCLFDisclosuresReferences";
import OrganizationExperience from "components/Rover/DeveloperApplications/CCLFDevelopersIntake/CCLFDeveloperApplication/OrganizationExperience";
import { IApplicationDetails } from "features/ApplicationForm/types";

export default function ChicagoRebuildApplicationDetails({
  applicationData,
  files,
}: IApplicationDetails) {
  return (
    <>
      <CCLFApplicationInformation
        organizationInformation={applicationData.organizationInformation}
        files={files}
      />
      <OrganizationExperience
        organizationExperience={applicationData.organizationExperience}
        files={files}
      />
      <CCLFApplicationLoan
        financialRequest={applicationData.financialRequest}
      />
      <CCLFDisclosuresReferences
        disclosuresReferences={applicationData.disclosuresReferences}
        files={files}
      />
    </>
  );
}
